import React from "react";
import { useNavigate } from "react-router-dom";

const Pricing = () => {
  const navigate = useNavigate();
  // Initialize Razorpay payment for Blacksite plan
  const initializeRazorpaySubscription = async () => {
    try {
      // Create a plan first
      const planResponse = await fetch(
        "https://intelligence.fozzil.in/payment/create-plan",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            period: "monthly",
            interval: 1,
            item: {
              name: "FOZZIL Intelligence Blacksite Plan",
              amount: 10120, // ₹99.00 + ₹2.20 convenience fee = ₹101.20 (in paise)
              currency: "INR",
              description:
                "Monthly subscription for FOZZIL Intelligence Blacksite Plan",
            },
            notes: {
              features: "FI1.1, FI2.4, Stealth Mode, Advanced Voice AI",
            },
          }),
        }
      );

      if (!planResponse.ok) {
        throw new Error("Failed to create plan");
      }

      const plan = await planResponse.json();

      // Create subscription with the plan
      const subscriptionResponse = await fetch(
        "https://intelligence.fozzil.in/payment/create-subscription",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            plan_id: plan.id,
            total_count: 120, // 10 years max
            customer_notify: true,
            notes: {
              features: "FI1.1, FI2.4, Stealth Mode, Advanced Voice AI",
              address: "Chennai, India",
            },
          }),
        }
      );

      if (!subscriptionResponse.ok) {
        throw new Error("Failed to create subscription");
      }

      const subscription = await subscriptionResponse.json();

      // Load Razorpay script
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        const options = {
          key: "rzp_live_RN4DlJkGqLQAzq",
          subscription_id: subscription.id,
          name: "FOZZIL Intelligence",
          description: "Blacksite Plan - ₹99/month + ₹2.20 convenience fee",
          image: "https://fozzil.in/logo.png",
          handler: async function (response) {
            try {
              // Verify the payment
              const verifyResponse = await fetch(
                "https://intelligence.fozzil.in/payment/verify-subscription",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_subscription_id: response.razorpay_subscription_id,
                    razorpay_signature: response.razorpay_signature,
                  }),
                }
              );

              if (!verifyResponse.ok) {
                throw new Error("Payment verification failed");
              }

              const verification = await verifyResponse.json();

              if (verification.success) {
                // Redirect to success page with subscription details
                window.location.href = `/payment-success?payment_id=${response.razorpay_payment_id}&subscription_id=${response.razorpay_subscription_id}`;
              } else {
                alert("Payment verification failed. Please contact support.");
              }
            } catch (error) {
              console.error("Verification error:", error);
              alert("Failed to verify payment. Please contact support.");
            }
          },
          prefill: {
            name: "FOZZIL User",
            email: "",
          },
          notes: {
            plan: "Blacksite",
            features: "FI1.1, FI2.4, Stealth Mode, Advanced Voice AI",
            address: "Chennai, India",
          },
          theme: {
            color: "#1a237e",
          },
          modal: {
            ondismiss: function () {
              console.log("Subscription modal closed");
            },
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", function (response) {
          console.error("Payment failed:", response.error);
          alert(`Payment failed: ${response.error.description}`);
        });

        try {
          rzp.open();
        } catch (error) {
          console.error("Error opening Razorpay:", error);
          alert(
            "Unable to open payment gateway. Please check your internet connection and try again."
          );
        }
      };

      script.onerror = () => {
        console.error("Failed to load Razorpay script");
        alert(
          "Payment system temporarily unavailable. Please try again later."
        );
      };

      document.body.appendChild(script);
    } catch (error) {
      console.error("Subscription initialization error:", error);
      alert("Failed to initialize subscription. Please try again later.");
    }
  };

  return (
    <>
      <div className="bg-black text-white font-secondary min-h-[100dvh] flex flex-col box-border relative">
        {/* Close button in top right corner */}
        <button
          onClick={() => navigate("/login")}
          className="fixed top-4 md:top-6 right-4 md:right-6 z-50 w-10 h-10 flex items-center justify-center text-white hover:text-red-400 transition-colors duration-300 hover:bg-white/10 rounded-full"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <section className="text-center py-6 max-w-4xl mx-auto px-4">
          <h1 className="font-primary text-2xl sm:text-3xl uppercase mb-3 text-white">
            FOZZIL INTELLIGENCE UPGRADE PLANS
          </h1>
          <div className="w-full h-0.5 bg-white"></div>
        </section>

        <section className="flex justify-center gap-3 flex-wrap max-w-6xl mx-auto px-4 py-6 md:py-8 flex-1 items-center overflow-y-auto">
          {/* BASIC PLAN */}
          <div className="bg-black border border-[#0099f2] rounded-xl p-3 flex flex-col items-start text-left box-border w-full sm:w-[280px] transition-all duration-500 ease-in-out relative h-auto min-h-[450px] hover:border-[#0099f2]/80 hover:shadow-md hover:shadow-[#0099f2]/10 hover:translate-y-[-2px]">
            <h2 className="font-primary text-xl uppercase text-white mb-0">
              BASIC
            </h2>
            <div className="flex items-end mb-4 mt-2">
              <span className="font-primary text-3xl text-white leading-none pt-4">
                Free
              </span>
            </div>
            <button className="basic-plan-btn block w-full py-2 px-4 mt-4 text-sm font-secondary font-bold text-white bg-transparent border border-white rounded-full cursor-not-allowed pointer-events-none opacity-85">
              Your current plan
            </button>
            <p className="text-sm text-[#bfc5c5] leading-5 my-3">
              Your entry into the world of FOZZIL Intelligence. Core features
              for everyday use.
            </p>
            <h3 className="font-secondary text-sm text-white mb-1 font-bold">
              Includes:
            </h3>
            <ul className="list-none p-0 m-0 text-[#bfc5c5] text-xs flex-grow">
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Ask, Search, and Basic Reasoning
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Lightweight tasks and responses
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Basic voice command interface
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Limited file uploads
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                No stealth or trace masking
              </li>
            </ul>
          </div>

          {/* BLACKSITE PLAN (middle card, scaled up) */}
          <div
            className="bg-black border-2 border-[#0099f2] rounded-xl p-4 flex flex-col items-start text-left box-border w-[300px] transition-all duration-700 ease-in-out relative scale-110 z-10 h-[480px] shadow-lg shadow-[#0099f2]/20 hover:border-[#00b8ff] hover:shadow-xl hover:shadow-[#0099f2]/40 hover:scale-[1.12] hover:translate-y-[-4px]"
            style={{ margin: 0 }}
          >
            <h2 className="font-primary text-xl uppercase text-white mb-0">
              BLACKSITE
            </h2>
            <div className="flex items-end mb-2 mt-2">
              <span className="font-primary text-3xl text-white leading-none pt-4">
                ₹99
              </span>
              <span className="font-secondary text-sm text-[#bfc5c5] ml-2 pb-1">
                /month
              </span>
            </div>
            <div className="mb-2">
              <p className="text-xs text-[#bfc5c5] text-center">
                + ₹2.20 convenience fee
              </p>
            </div>
            <button
              className="blacksite-upgrade-btn block w-full py-2 px-4 mt-4 text-sm font-secondary font-bold text-white rounded-full cursor-pointer transition-all duration-300 ease-in-out hover:transform hover:-translate-y-1 hover:shadow-lg uppercase tracking-wide"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/payment");
              }}
            >
              Upgrade Now
            </button>
            <p className="text-sm text-[#bfc5c5] leading-5 my-3">
              This is for those who operate in shadows, demand peak performance,
              and value total digital invisibility.
            </p>
            <h3 className="font-secondary text-sm text-white mb-1 font-bold">
              Includes everything in Basic:
            </h3>
            <ul className="list-none p-0 m-0 text-[#bfc5c5] text-xs flex-grow overflow-y-auto">
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                FI1.1 and FI2.4 Intelligence Engines (next-generation thinking
                models)
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Advanced Deep Think Mode
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Stealth Mode - leaves no trace
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Enhanced messaging and file handling
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Full creative suite (image generation, voice, multi-modal
                inputs)
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Standard and Advanced Voice AI
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Deep research preview (FI2.4 Research Model)
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Fast, multi-layered reasoning and content generation
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Create and manage: Tasks, Projects, Dynamic Planning
              </li>
              <li className="mb-1 relative pl-4 before:content-['•'] before:text-white before:absolute before:left-0 before:top-0">
                Early access to experimental tools
              </li>
            </ul>
          </div>

          {/* EXTREMIS PLAN */}
          <div className="bg-black border border-[#0099f2] rounded-xl p-3 flex flex-col items-start text-left box-border w-full sm:w-[280px] transition-all duration-500 ease-in-out relative h-auto min-h-[450px] hover:border-[#0099f2]/80 hover:shadow-md hover:shadow-[#0099f2]/10 hover:translate-y-[-2px]">
            <h2 className="font-primary text-xl uppercase text-white mb-0">
              EXTREMIS
            </h2>
            <p className="text-sm text-[#bfc5c5] leading-5 my-4">
              The future of hyper-personalized intelligence.
            </p>
            <p className="font-primary text-lg text-white mt-8 text-center w-full">
              Coming Soon...
            </p>
          </div>
        </section>

        {/* Terms and Privacy Section */}
        <div className="text-center text-xs text-[#bfc5c5] px-4 py-6 max-w-2xl mx-auto">
          By subscribing, you agree to FOZZIL's{" "}
          <a
            href="https://fozzil.in/terms-of-use"
            className="text-[#0099f2] hover:text-[#00b8ff] hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>{" "}
          and{" "}
          <a
            href="https://fozzil.in/privacy-policy"
            className="text-[#0099f2] hover:text-[#00b8ff] hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          . We may change our prices as described in our{" "}
          <a
            href="https://fozzil.in/terms-of-use"
            className="text-[#0099f2] hover:text-[#00b8ff] hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
        </div>
      </div>

      <style jsx>{`
        .basic-plan-btn {
          background: transparent !important;
          border: 1px solid white !important;
        }

        .blacksite-upgrade-btn {
          position: relative;
          border: 1px solid transparent;
          background: linear-gradient(transparent, transparent) padding-box,
            linear-gradient(90deg, #0099f2 0%, #1a6dff 50%, #c822ff 100%)
              border-box;
          background-clip: padding-box, border-box;
          transition: all 0.3s ease;
        }

        .blacksite-upgrade-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 153, 242, 0.4);
        }
      `}</style>
    </>
  );
};

export default Pricing;
